import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router'
import { useUser } from '@clerk/clerk-react'
import { getUserFromClerkId } from '@/hooks/useUser'
import ScamCheckerHero from '@/components/tools/ScamCheckerHero'
import BreachMonitorCard from '@/components/tools/BreachMonitorCard'
import PasswordCheckCard from '@/components/tools/PasswordCheckCard'
import CharityCheckCard from '@/components/tools/CharityCheckCard'
import ScamLibraryCard from '@/components/tools/ScamLibraryCard'

export const Route = createFileRoute('/_auth/tools')({
  component: RouteComponent,
})

/**
 * The Tools hub. One front door (the Scam Checker hero, no mode tabs:
 * we detect link vs message, screenshots attach inline, and "describe what
 * happened" covers everything else), then four single-purpose tool cards.
 * Rebuilt greenfield 2026-06-12 (TD-016 Tier 3).
 */
function RouteComponent() {
  const router = useRouter()
  const isIndex = router.state.location.pathname === '/tools'
  const { user: clerkUser } = useUser()
  const userQuery = getUserFromClerkId(clerkUser?.id || '', { enabled: !!clerkUser?.id })
  const userMarket = userQuery.data?.market || 'GB'

  if (!isIndex) {
    return <Outlet />
  }

  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <div className="mx-auto max-w-5xl px-4 pb-24 pt-10 sm:px-6 lg:px-8">
        <header className="mb-8 px-1">
          <h1 className="text-[clamp(1.7rem,3.5vw,2.5rem)] font-semibold leading-tight tracking-tight text-slate-900">
            Tools
          </h1>
          <p className="mt-2 max-w-[58ch] text-[17px] leading-relaxed text-slate-600">
            Check anything that doesn't feel right, and keep your{' '}
            {userMarket === 'US' || userMarket === 'CA' ? 'defenses' : 'defences'} in good shape.
            Use them as often as you like.
          </p>
        </header>

        <div className="space-y-5">
          <ScamCheckerHero />

          <h2 className="px-1 pt-3 text-[1.05rem] font-semibold tracking-tight text-slate-900">
            More ways to stay safe
          </h2>
          <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
            <BreachMonitorCard />
            <ScamLibraryCard />
            <CharityCheckCard />
            <PasswordCheckCard />
          </div>
        </div>
      </div>
    </div>
  )
}
